import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

import BlueFireworkPanel from '../../components/blueFireworkPanel';
import {pxToEm} from '../../components/globalStyles';
import LiveEncodingNoteworthyFeatureData from '../../data/liveEncodingNoteworthyFeatureData';
import {RootState} from '../../logic/store';
import {State as SalesDemosState} from '../../logic/store/salesDemosStore';

import NoteworthyFeature from './noteworthyFeature';

//#region Styled Components

const StyledBlueFireworkPanel = styled(BlueFireworkPanel)`
  color: white;
  border-radius: 8px;
`;

const StyledFeaturesWrapperDiv = styled.div`
  padding-left: ${pxToEm(53)}em;
  padding-right: ${pxToEm(90)}em;
  padding-top: ${pxToEm(53)}em;
  padding-bottom: ${pxToEm(53)}em;
  line-height: 1.333;
`;

const StyledNoteworthyFeature = styled(NoteworthyFeature)`
  :not(:last-child) {
    margin-bottom: ${pxToEm(42)}em;
  }
`;

//#endregion

interface MapStateToProps {
  salesDemos?: SalesDemosState;
}

interface Props extends MapStateToProps {
  className?: string;
}

class NoteworthyFeaturesSection extends React.Component<Props> {
  public render() {
    return (
      <StyledBlueFireworkPanel
        fireworks={[{bottom: '-30%', right: '-25%', width: '115%'}]}
        className={this.props.className}>
        <StyledFeaturesWrapperDiv>
          {LiveEncodingNoteworthyFeatureData.map((feature, index) => (
            <StyledNoteworthyFeature key={`live-encoding-noteworthy-feature-${index}`} feature={feature} />
          ))}
        </StyledFeaturesWrapperDiv>
      </StyledBlueFireworkPanel>
    );
  }
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
  salesDemos: state.salesDemos
});

export default connect(mapStateToProps)(NoteworthyFeaturesSection);
